import React from 'react';

import { Tabs, Tab, Grid, Button, Box, Divider, CircularProgress, Typography } from '@mui/material';
import CompanyAdd from './CompanyAdd';
import { VisibilityOutlined } from "@mui/icons-material";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MenuList from 'Containers/Menu/MenuList';
import ServerUpdate from './ServerUpdate';
import CompanyChecklistTab from './CompanyChecklistTab';

function CompanyTabs(props) {
    const navigate = useNavigate();
    const [value, setValue] = React.useState();
    const [company_id, set_company_id] = React.useState('');
    const [is_edit_form, set_is_edit_form] = React.useState(false);
    const [loading, set_loading] = React.useState(true);
    const location = useLocation();
    React.useEffect(() => {
        if (location.pathname === '/company/edit/') {
            if (location.state && location.state.detail) {
                let id = location.state.detail;
                set_company_id(id);
                set_is_edit_form(true);
                set_loading(false);
                setValue(0);
            } else {
                navigate('/company/list/');
            }
        } else {
            setValue(0);
            set_loading(false);
        }
    }, []);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <>
            {loading &&
                <>
                    <CircularProgress />
                </>
            }
            {!loading &&
                <>
                    <Grid container>
                        <Grid item md={6} xs={12}  mt={2} className='header-align'>
                        <Typography variant="h5" fontWeight={600}>
                                Company Informations
                            </Typography>
                        </Grid>
                        <Grid item md={6} xs={12} >
                            <Box className='header-align end-flex-prop'>
                                <Button
                                    variant='contained'
                                    component={Link} to={'/company/list'}
                                    className='editbutton-view'
                                ><VisibilityOutlined className='visibility-icon' /> View Company</Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box mt={3} >
                        <Divider />
                    </Box>
                    <Tabs value={value} onChange={handleChange} aria-label="tab-custom-css tabs example">
                        <Tab label="Company Details" sx={{ display: 'none' }} />
                        {is_edit_form &&
                            <Tab label="Menu List" />
                        }
                        {is_edit_form &&
                            <Tab label="Service List" />
                        }
                        {is_edit_form &&
                            <Tab label="Server Update" />
                        }
                        {is_edit_form &&
                            <Tab label="Checklist" />
                        }
                    </Tabs>
                    <Box className='mv-30'>
                        {value === 0 &&
                            <CompanyAdd
                                is_edit_form={is_edit_form}
                                company_id={company_id}
                                agreementPrefill={location.state?.agreementPrefill}
                            />
                        }
                        {value === 1 &&
                            <MenuList company_id={company_id} />
                        }
                        {value === 2 &&
                            <CompanyAdd company_id={company_id} />
                        }
                        {value === 3 &&
                            <ServerUpdate company_id={company_id} />
                        }
                        {value === 4 &&
                            <CompanyChecklistTab company_id={company_id} />
                        }
                    </Box>
                </>
            }
        </>
    )

}

export default CompanyTabs;